import { Box, IconButton } from '@chakra-ui/react';
import React from 'react';
import { FaBars } from 'react-icons/fa';

const FloatingMenu = ({ isModalOpen, closeModal, openModal, title }) => {
    return (
        <>
            {title !== '/dashboard/store' && (
                <Box pos="absolute" zIndex="100" left="1rem" top="2.5rem">
                    <IconButton
                        icon={<FaBars />}
                        onClick={openModal}
                        aria-label="Open menu"
                        bg="transparent"
                        color="#1b3b5f"
                        size="md"
                        _hover={{
                            bg: 'rgba(33, 33, 241, 0.1)',
                            transform: 'scale(1.05)',
                        }}
                        _active={{
                            transform: 'scale(0.95)',
                        }}
                        transition="all 0.2s ease"
                    />
                </Box>
            )}
        </>
    );
};

export default FloatingMenu;
